import React, { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import rutaTematicaApi from '../api/ruta-tematica';
const parse = require('url-parse');

const useRutaTematicaData = () => {
    const [data, setData] = useState();
    const [isValid, setIsValid] = useState(false);
    const { idrt, opc } = parse(location.href, true).query;
    if (idrt && opc) {
        useEffect(() => {
            rutaTematicaApi.get(`/rutatematica/${idrt}/${opc}`).then(res => {
                setData(res.data.data);
                setIsValid(true);
            }).catch(err => {
                console.warn("No se encontró una ruta tematica para los parametros dados.");
                setData(null);
            })
        }, []);
    }

    return [{ data, params: [idrt, opc] }, isValid];
}

const renderLink = (text, url, withSlash = true) => {
    return (
        <React.Fragment key={text}>
            <li key={text}>
                {url === "" ? text : <a href={url}>{text}</a>}
            </li>
            {withSlash ? <li>/</li> : null}
        </React.Fragment>
    )
}

const renderUrl = (navigation) => {
    let newUrl = [renderLink("Inicio", "/default.html")]
    if (navigation.params[1] === "p")
        newUrl.push(renderLink("Programas", "/programas"))
    else
        newUrl.push(renderLink("Temas", "/datos"))

    navigation.data.forEach((t, index, arr) => {
        if (index === arr.length - 1)
            newUrl.push(renderLink(t.texto, t.enlace, false))
        else
            newUrl.push(renderLink(t.texto, t.enlace))
    });
    return newUrl;
}

const RutaTematica = () => {
    const ref = useRef(document.getElementById("listTemas"));
    const [navigation, isValid] = useRutaTematicaData();
    const [isRefClean, setIsRefClean] = useState(false);
    const url = isValid ? renderUrl(navigation) : null;
    useEffect(() => {
        if (isValid && !isRefClean) {
            while (ref.current.firstChild)
                ref.current.removeChild(ref.current.firstChild)
            setIsRefClean(true)
        }
    }, [isValid])
    return (
        isRefClean ?
            ReactDOM.createPortal(
                url,
                ref.current
            ) : null
    )
}

export default RutaTematica;
